import { createRef } from 'react';
import DeviceScreen, { MEDIUM } from 'lib/DeviceScreen';

function isNavbarBetween(navbarBottom, before, after) {
  return (
    navbarBottom + 10 >= before.current.offsetTop &&
    navbarBottom < after.current.offsetTop
  );
}

export default class {
  constructor() {
    this.props = {
      refs: {
        featured: createRef(),
        guides: createRef(),
        reviews: createRef(),
        slideshows: createRef(),
        navbar: createRef(),
        hero: createRef(),
      },
    };
  }

  scrollPositionForSection(section) {
    const offset = this.props.refs[section].current.offsetTop;

    return (
      offset -
      (DeviceScreen.isAtMost(MEDIUM.maxWidth)
        ? this.props.refs.navbar.current.offsetHeight
        : 0)
    );
  }

  isNavbarInHero() {
    const hero = this.props.refs.hero.current;
    const initialNavbarOffsetTop =
      hero.offsetTop +
      hero.offsetHeight -
      this.props.refs.navbar.current.offsetHeight;

    return this.props.refs.navbar.current.offsetTop === initialNavbarOffsetTop;
  }

  currentSection() {
    const navbarBottom =
      this.props.refs.navbar.current.offsetTop +
      this.props.refs.navbar.current.offsetHeight;

    if (navbarBottom < this.props.refs.guides.current.offsetTop) {
      return 'featured';
    }
    if (
      isNavbarBetween(
        navbarBottom,
        this.props.refs.guides,
        this.props.refs.reviews
      )
    ) {
      return 'guides';
    }
    if (
      isNavbarBetween(
        navbarBottom,
        this.props.refs.reviews,
        this.props.refs.slideshows
      )
    ) {
      return 'reviews';
    }
    if (navbarBottom >= this.props.refs.reviews.current.offsetTop) {
      return 'slideshows';
    }

    throw new Error(`Invalid navbar position`);
  }
}
